import { css } from '@emotion/core'
import { useSelector } from 'react-redux'
import { isRtlSelector } from 'redux/selectors/general'
import { IPop } from 'constants/interfaces'
import { Avatar, Flex, Box } from '@chakra-ui/core'
import React from 'react'
import StoreeDoll from 'assets/doll_icon.png'

// CSS for bubble animation
const bubbleAnimation = css`
  animation: bubble 1.4s infinite ease-in-out;
  @keyframes bubble {
    0%,
    80%,
    100% {
      transform: scale(0.8);
      opacity: 0.5;
    }
    40% {
      transform: scale(1.2);
      opacity: 1;
    }
  }
`

// Component: avatar + black dot
export const BotThinkingBubble = ({ pop }: { pop?: IPop }) => {
  const isRtl = useSelector(isRtlSelector)
  const { profile_image_url, avatar_profile_img_url } = pop || {}
  const botAvatar = profile_image_url || avatar_profile_img_url || StoreeDoll

  return (
    <Flex align={isRtl ? 'flex-end' : 'flex-start'} textAlign="center" py="16px" px="15px">
      <Flex align="center" justify="center" style={{ gap: '10px' }}>
        <Avatar
          src={botAvatar}
          name="Storee"
          size="md"
          bg="transparent"
          style={{
            filter: 'drop-shadow(0 3px 1px rgba(0, 0, 0, 0.19))',
          }}
        />
        <Box width="12px" height="12px" borderRadius="50%" backgroundColor="#000" css={bubbleAnimation} />
      </Flex>
    </Flex>
  )
}
